import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RoomHeaderRoomDeleted } from '../../../stores/rooms/rooms.actions';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-room-delete-modal',
  templateUrl: './room-delete-modal.component.html',
  imports: [],
})
export class RoomDeleteModalComponent {
  private readonly store = inject(Store);
  public readonly activeModal = inject(NgbActiveModal);

  public readonly room = this.store.selectSignal(selectCurrentRoom);

  deleteRoom() {
    const room = this.room();
    if (!room) return;
    this.store.dispatch(new RoomHeaderRoomDeleted(room));
    this.activeModal.close();
  }
}
